<div class="stepper" *transloco="let t">
  <div class="mt-2">
    <ol class="stepper-progress is-titled">
      @for (step of steps; track step; let i = $index) {
        <li [ngClass]="{'is-complete': step.completed, 'is-active': step.active}" (click)="doSelectStep(step,i)"><span>{{step.translationKey ? t(step.translationKey) : step.text}}</span></li>
      }
    </ol>
  </div>
</div>
